import TopNav from "./layout/TopNav";
import { BrowserRouter } from "react-router-dom";
import Routes from "./routes";

function App() {
  return (
    <BrowserRouter>
      <div className="app">
        <TopNav title={"Boogie Juice"} />
        <Routes />
      </div>
    </BrowserRouter>
  );
}

export default App;
